<template>
    <div class="container-fluid" >
        <headerApp :title="this.translate('chatTitle')"></headerApp>
        <div class="row">
            <div class="col-xs-24">
                <div class="row">
                    <div class="chat-messages">
                        <div v-for="message in messages" v-bind:key="message.id != null ? message.id : 'tmp-' + message.tempId" class="message" :class="{'message-me': me.id === message.usuario_id}">
                            <span class="message_sender">
                                {{ me.id !== message.usuario_id ? (counterMe.nombre + ' ' + counterMe.apellido) : '' }}
                            </span>
                            <template v-if="message.type === 0">
                                <span class="message_content">{{ message.mensaje }}</span>
                            </template>
                            <template v-if="message.type === 1">  <!-- AUDIO -->
                                <div class="audio-player">
                                    <audio-buttons :audio=" message ? message.audio : null "></audio-buttons>
                                </div>
                                <div class="audio-status">
                                    <template v-if="message.audio">
                                        <progress :max="100" :value="message.audio.positionPercentage">
                                        </progress>
                                        <div class="audio-duration">{{ message.audio.durationMinutes }}:{{ message.audio.durationSeconds }}</div>
                                    </template>
                                    <template v-else>
                                        {{ translate('procesandoAudio') }}
                                    </template>
                                </div>
                            </template>
                            <span class="message_time">
                                <span class="time">{{ message.created_at | moment('HH:mm') }}</span>
                                <svg-item :size="17" :icon="'double-check'" :color="'--main-color'" v-if="me.id === message.usuario_id && message.visto"></svg-item>
                            </span>
                        </div>
                    </div>
                    <div class="chat-form">
                        <input type="text" :placeholder="translate('escribaMensaje')" v-model="text">
                        <button  v-if="!textIsComplete" :class="{ 'isRecording': isRecording}" v-on:touchstart="onStartRecord" v-on:touchend="onStopRecord" v-on:touchcancel="onStopRecord">
                            <svg-item :size="28" :icon="'microfono'" :color="!isRecording ? '--main-color' : '#FFF'"></svg-item>
                        </button>
                        <button @click="onSendMessage" v-show="textIsComplete">
                            <svg-item :size="28" :icon="'send'" :color="'--main-color'"></svg-item>
                        </button>

                        <button v-if="settings && settings.mensajes_prearmados" @click="onAutoMessageClick(true)">
                            <svg-item :size="28" :icon="'message'" :color="'--main-color'"></svg-item>
                        </button>

                    </div>
                </div>
            </div>
        </div>
        <div v-show="showMessageDialog">
            <div class="automassage_cortina" @click="onAutoMessageClick(false)"></div>
            <div  class="automassage_container">
                <ul>
                    <li v-for="message in settings.mensajes_prearmados" @click="onMessageClick(message)">
                        {{ message }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Thread } from '@movilizame/networking';
import moment from 'moment';
import audioButtons from '../elements/AudioButtons';

export default {
    name: 'chat',
    props: [
        'id'
    ],
    data () {
        return {
            text: '',
            isRecording: false,
            showMessageDialog: false
        };
    },
    computed: {
        ...mapGetters({
            isChofer: 'auth/isChofer',
            driverTrip: 'driver/actualTrip',
            passengerTrip: 'passenger/actualTrip',
            messages: 'messages/chats',
            me: 'auth/user',
            settings: 'company/config'
        }),
        counterMe () {
            if (!this.isChofer) {
                return this.passengerTrip.chofer.usuario;
            } else {
                return this.driverTrip.pasajero;
            }
        },
        chatId () {
            let raw = null;
            if (!this.id) {
                if (this.isChofer) {
                    raw = this.driverTrip && this.driverTrip.id;
                } else {
                    raw = this.passengerTrip && this.passengerTrip.id;
                }
            } else {
                raw = this.id;
            }
            if (raw === null || raw === undefined || raw === '') {
                return null;
            }
            const n = Number(raw);
            return Number.isNaN(n) ? null : n;
        },
        textIsComplete () {
            return this.text !== '';
        }
    },
    beforeMount () {
        if (this.chatId != null) {
            this.$store.commit('messages/SET_CURRENT_CONVERSATION', this.chatId);
        }
    },
    mounted () {
        this.startMessagePoll();
    },
    methods: {
        startMessagePoll () {
            Thread.stopThreads('messages');
            if (this.chatId == null) {
                return;
            }
            let vm = this;
            let thread = new Thread({ interval: 20 * 1000, runImmediately: true });
            thread.action(({next}) => {
                if (vm.chatId == null) {
                    next();
                    return;
                }
                vm.$store.commit('messages/SET_CURRENT_CONVERSATION', vm.chatId);
                let lastId = null;
                if (vm.messages && vm.messages.length) {
                    let messages = vm.messages.slice();
                    messages.reverse();
                    let m = messages.find(m => m.usuario_id !== vm.me.id);
                    if (m) {
                        lastId = m.id;
                    }
                }
                vm.getMessages({
                    chatId: vm.chatId,
                    lastId: lastId
                });
                next();
            }).tag('messages').run();
        },
        ...mapActions({
            getMessages: 'messages/getMessages',
            sendMessage: 'messages/sendMessage',
            startRecord: 'messages/startRecord',
            stopRecord: 'messages/stopRecord',
            cancelRecord: 'messages/cancelRecord',
            markAsRead: 'messages/markAsRead'
        }),
        onMessageClick (message) {
            this.showMessageDialog = false;
            this.text = message;
            this.onSendMessage();
        },
        onAutoMessageClick (show) {
            this.showMessageDialog = show;
        },
        onSendMessage () {
            if (this.text.trim() !== '') {
                let data = {
                    isAudio: false,
                    type: 0,
                    mensaje: this.text,
                    viaje_id: this.chatId,
                    usuario_id: this.me.id,
                    created_at: moment().format('YYYY-MM-DD HH:mm:ss')
                };
                this.sendMessage(data);
                this.text = '';
            }
        },
        onStartRecord () {
            this.isRecording = true;
            this.startRecord({ viajeId: this.chatId });
        },

        onStopRecord () {
            this.isRecording = false;
            this.stopRecord({ viajeId: this.chatId });
        },
        onCancelRecord () {
            this.isRecording = false;
            this.cancelRecord();
        },
        onPlayAudio (message) {
            if (message.audio && message.audio.play) {
                message.audio.play();
            }
        },
        onPauseAudio (message) {
            if (message.audio && message.audio.pause) {
                message.audio.pause();
            }
        }
    },
    beforeDestroy () {
        Thread.stopThreads('messages');
    },
    watch: {
        chatId (n, o) {
            if (n === o) {
                return;
            }
            if (this.chatId != null) {
                this.$store.commit('messages/SET_CURRENT_CONVERSATION', this.chatId);
            }
            this.startMessagePoll();
        },
        messages () {
            this.$nextTick(() => {
                var container = this.$el.querySelector('.chat-messages');
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
                this.markAsRead();
            });
        }
    },
    components: {
        'audio-buttons': audioButtons
    }
};
</script>

<style scoped>
    .container-fluid {
        background: var(--main-color);
        min-height: 100%;
    }
    .message {
        min-width: 30%;
        max-width: 80%;
        padding: .3em 1em 1em 1em;
        margin-top: 1em;
        background-color: var(--form-background);
        float: left;
        clear: both;
        border-radius: 6px;
        position: relative;
        margin-left: 15px;
    }
    .message .message_time,
    .message .message_content {
        display: block;
    }
    .message-me {
        padding-top: .6em;
        float: right;
        margin-left: 0;
        margin-right: 15px;
    }
    .message-me .message_content {
        text-align: right;
    }
    .message_sender {
        font-size: 0.75rem;
        color: var(--main-softer-color);
        position: relative;
        z-index: 1;
        display: block;
    }
    .message-me .message_sender {
        display: none;
    }
    .message_time {
        text-align: right;
        color: var(--text-softer-color);
    }
    .message_time > * {
        vertical-align: middle;
    }
    .message_time .time {
        font-size: 0.65rem;
        vertical-align: -2px;
    }
    .chat-messages {
        height: calc(100vh - var(--header-height) - var(--ios-pad) - 60px);
        overflow-y: scroll;
        overflow-x: hidden;
    }
    .chat-messages:after {
        content: " ";
        display: block;
        height: 30px;
        clear: both;
    }
    .chat-form {
        clear: both;
        background-color: var(--form-background);
        border-top: 2px solid #DDD;
        padding: .5em;

        position: fixed;
        bottom: 0;

        height: 60px;
        width: 100%;
        overflow: hidden;
    }
    .chat-form input {
        width: calc(85% - .5em);
        border: 0;
    }

    .chat-form > button {
        display: inline-block;
        width: calc(15% - 1em + .5em);
        height: calc(100% + .5em);
        margin-top: -0.25em;
        margin-right: -.5em;
        overflow: hidden;
    }

    .chat-form button {
        border: 0;
        border-radius: 100%;
        background: transparent;
        text-align: center;
    }
    .chat-form button.isRecording {
        background: var(--alert-color);
    }
    .message:after{
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        left: -15px;
        right: auto;
        top: 0px;
        bottom: auto;
        border: 22px solid;
        border-color: white transparent transparent transparent;
        pointer-events: none;
        z-index: 0;
    }
    .message-me:after{
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        left: auto;
        right: -15px;
        top: 0px;
        bottom: auto;
        border: 20px solid;
        border-color: #FFF transparent transparent transparent;
        z-index: 0;
    }
    .audio-player,
    .audio-status {
        display: inline-block;
        vertical-align: middle;
    }
    .audio-player button {
        background: transparent;
        border: 0;
    }
    .audio-status progress {
        min-width: 160px;
    }
    .audio-status .audio-duration {
        font-size: 0.68rem;
    }
    progress {
        -webkit-appearance: none;
        min-width: 150px;
        height: 4px;
    }
    progress[value]::-webkit-progress-bar {
        background: #F5F5F5;
        border-radius: 2px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.10) inset;
        height: 4px;
    }
    progress[value]::-webkit-progress-value {
        border-radius: 2px;
        background: var(--main-color);
    }

    .automassage_container {
        background-color: white;
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        border-radius: 10px;
        z-index: 100;
    }

    .automassage_cortina {
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        height: 100vh;
        z-index: 97;
        opacity: 0.5;
        background-color: grey;
    }

    .automassage_container ul {
        padding: 0;
        padding-inline-start: 0;
        margin-top: 10px;
        list-style-type: none;
        z-index: 98;
    }

    .automassage_container li {
        font-size: 14px;
        padding: 5px;
        padding-left: 20px;
    }

    .automassage_container li:hover {
        background-color: rgba(128, 128, 128, 0.238);
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Chat.vue